export const currencyParser = (value: number | string): string => {
    const amountInKopecks = Number(value)
    const sign = amountInKopecks < 0 ? '-' : ''
    const absKopecks = Math.abs(amountInKopecks)
    const rubles = Math.floor(absKopecks / 100)
    const kopecks = absKopecks % 100

    return kopecks === 0 ?
            `${sign}${rubles}`
        :   `${sign}${rubles},${String(kopecks).padStart(2, '0')}`
}

export const currencyParserToNumber = (value: string): number => {
    if (value.includes(',')) {
        const [currency, penny] = value.split(',')
        const pennyNumber = penny.length === 1 ? `${penny}0` : penny

        return Number(`${currency}${pennyNumber}`)
    }

    return Number(`${value}00`)
}
